module.exports = __webpack_public_path__ + "img/demoProgressDataImg.7d45c6c2.svg";